import { render, staticRenderFns } from "./TeachingListAction.vue?vue&type=template&id=bb9669b4"
import script from "./TeachingListAction.vue?vue&type=script&lang=js"
export * from "./TeachingListAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports